module.exports = __webpack_public_path__ + "img/stoperInLaptop@3.ec7be120.png";